import { render, staticRenderFns } from "./coupon-discount-content.vue?vue&type=template&id=666a71a9&scoped=true&"
import script from "./coupon-discount-content.vue?vue&type=script&lang=ts&"
export * from "./coupon-discount-content.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-discount-content.vue?vue&type=style&index=0&id=666a71a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a71a9",
  null
  
)

export default component.exports